import toutiao_app from '@/router/toutiao_app'//头条小程序页面
export default {
	components: {

	},
	data() {
		return {

		}
	},
	mounted() {
		let locationHref = location.href
		let istToutiaoRouter = this.checkRouter()
		let isToutiaoRoute = ['extendingCenter','','']
		if (locationHref.indexOf('xinli001wx.com') != -1 && istToutiaoRouter) {
			console.log('该页面为旧域名的广告页')
			this.$router.push({
				name:"toutiaono"
			})
		}
		// this.checkToutiao()
	},
	methods: {
		checkRouter(){
			const that = this
			// console.log(this.$router)
			let routeNames = []
			toutiao_app.map((item, index)=> {
				routeNames.push(item.name)
				if (item.children) {
					item.children.map((one,i) => {
						routeNames.push(one.name)
					})
				} 
			})

			var istToutiaoRouter = false
			routeNames.map((item, index) => {
				// console.log(that.$route)
				if (item == that.$route.name) {
					istToutiaoRouter = true
				}
			})
			console.log('istToutiaoRouter',istToutiaoRouter)
			return istToutiaoRouter
		}
	}
}


// WEBPACK FOOTER //
// ./src/mixins/toutiaoMixin.js